import _ from 'lodash';

const UUID_PREFIX_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

export const isDisplayable = value =>
  !_.isNil(value) && !UUID_PREFIX_PATTERN.test(value) && value !== 'edit' && value !== 'all-views';

export const deduplicateByConnectionId = users =>
  Object.values(
    users.reduce((acc, user) => {
      const key = user.connectionId ?? user.userId;

      if (_.isNil(acc[key])) {
        acc[key] = user;
      }

      return acc;
    }, {}),
  );

export const buildUserLocationPath = (user, entityNameMap) => {
  const parts = [];
  const meta = user.metadata;
  const entityName =
    meta?.entityName ?? (!_.isNil(user.entityId) ? entityNameMap[user.entityId] : null);

  if (isDisplayable(user.subtab)) {
    parts.push(meta?.subtabName ?? _.startCase(user.subtab));
  }

  if (!_.isNil(entityName)) {
    parts.push(entityName);
  }

  if (isDisplayable(user.sectionId)) {
    parts.push(_.startCase(user.sectionId));
  }

  if (!_.isNil(user.subsection)) {
    const subsectionName = meta?.subsectionName ?? entityNameMap[user.subsection];

    if (!_.isNil(subsectionName)) {
      parts.push(subsectionName);
    }
  }

  return parts.join(' → ');
};
